// extracted by mini-css-extract-plugin
export default {"dropZone":"DropZoneURL_dropZone__u9pQI","inputURL":"DropZoneURL_inputURL__hIwUo"};